import type { ITranslationObject } from "@krea/shared/types/common";

import en from "./en.json";
import fi from "./fi.json";
import sv from "./sv.json";

export const applicationPreviewTranslations: ITranslationObject<typeof en> = {
  en,
  sv,
  fi,
  namespace: "applicationPreview",
};

export interface IApplicationPreviewTranslations {
  applicationPreview: (typeof applicationPreviewTranslations)["en"]["applicationPreview"];
}
